import { useEffect } from 'react';
import { injectGtm } from './gtm';

/** Client-side mirror of `brands.gtm_container_id` keyed by taker host, for
 *  pages that render without a brand payload (thanks/checkout/magnet) or whose
 *  brand fetch failed. D1 is the source of truth — if a brand's container id
 *  changes there, or a new brand taker host gains its own container, update
 *  this map in the same change (same sync discipline as
 *  KNOWN_BRAND_TAKER_HOSTS in worker/src/url-utm.ts).
 *  NEVER add GTM-P9JBHRD here — that is accelerate2advisor.com's container in
 *  a different Google account. */
const HOST_CONTAINERS: Record<string, string> = {
  'discover.purebookkeeping.com': 'GTM-PVQ947Z',
  'getbkos.com': 'GTM-W3QLRBJS',
};

/** Mount the brand's GTM container on a marketing-surface page.
 *
 *  - `containerId` — the brand's container from the public API
 *    (`brand.gtmContainerId`). Pass undefined when the page has no brand
 *    payload (or it failed to load); the host map above then resolves the
 *    container, falling back to TSB's GTM-TTZVPNB inside injectGtm.
 *  - `ready` — pass false while a brand payload is still loading so a
 *    non-TSB brand is never preceded by the TSB fallback (two containers on
 *    one page double-counts pageviews). Utility pages (booking, preference
 *    centre, cohort portal, door pages) intentionally do NOT call this hook.
 */
export function useBrandGtm(containerId?: string | null, ready = true): void {
  useEffect(() => {
    if (!ready) return;
    injectGtm(containerId ?? HOST_CONTAINERS[window.location.hostname] ?? null);
  }, [containerId, ready]);
}
